import React from 'react'
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { SearchInput } from '../search/SearchInput';
import { LinearProgress, Typography } from "@material-ui/core";
import { SignaMedLogo } from '../utils/SignaMedLogo'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from "react-i18next";

/* Custom Grid toolbar */
export function CustomToolbar({ value, setValue }) {
    return (
        <GridToolbarContainer>
            <SearchInput value={value} setValue={setValue} />
            {/*<GridFilterToolbarButton />
            <GridColumnsToolbarButton />
            <GridDensitySelector />
            <GridToolbarExport />*/}
        </GridToolbarContainer>
    );
}

/* Custom loading bar */
export function CustomLoading() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
        </GridOverlay>
    );
}

/* No rows message */
export function CustomNoRowsOverlay() {
    const { t } = useTranslation("global")
    return (
        <GridOverlay className='sig_SignsDB_Norows' style={{'textAlign': 'center'}}>
            <SignaMedLogo size={50} />
            <Typography variant='h6'> {t("sTable.search_no_results")} </Typography>
        </GridOverlay >
    )
}

export function CustomNoRowsOverlaySubmission() {
    const { t } = useTranslation("global")
    return (
        <GridOverlay className='sig_SignsDB_Norows' style={{'textAlign': 'center'}}>
            <SignaMedLogo size={50} />
            <Typography variant='h6'> {t("sTable.search_no_results")} </Typography>
            <hr></hr>
            <Typography variant='body2'> {t("sTable.search_no_results_submission")} </Typography>
            <Typography variant='body2'> {t("sTable.search_no_results_submission2")} <AddCircleIcon color='primary'/></Typography>
        </GridOverlay >
    )
}

export function CustomNoTags() {
    return (
        <GridOverlay className='sig_SignsDB_Norows'>
            <SignaMedLogo size={60} />
            <Typography variant='subtitle1'>No se ha seleccionado ninguna etiqueta</Typography>
        </GridOverlay >
    )
}


/* No bugs message */
export function CustomNoBugsOverlay(admin_lookup) {
    return (
        <GridOverlay className='sig_SignsDB_Norows'>
            <SignaMedLogo size={60} />
            {!admin_lookup ? 
            <>
            <div className='sig_BugReport_NoRowsMessage'>
                <Typography variant='subtitle1'>No hay incidencias propias que mostrar.</Typography>
                <Typography variant='subtitle1'>Para ver las creadas por otros usuarios, marcar la opción de "incidencias globales" en los botones superiores.</Typography>
            </div>
            </> 
            : 
            <>
            <div className='sig_BugReport_NoRowsMessage'>
                <Typography variant='subtitle1'>Cargando...</Typography>
            </div>
            </>
            }
        </GridOverlay >
    )
}